export interface LtiRegistrationSummary {
  id: number;
  publicId: string;
  name: string;
  audience: string;
  hasDeepLinking: boolean;
}

export default {
  activeRegistrations: [] as LtiRegistrationSummary[],
};
